import styled, { css } from 'styled-components';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;
const { SIDEBAR_WIDTH } = constants.sidebar;

export const LayoutContainer = styled.div`
  position: relative;
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

export const ViewerContainer = styled.div`
  @media ${DEVICE.DESKTOP} {
    position: relative;
    flex: 1;
    order: 2;
    height: 100%;

    ${({ isInScreenshotMode }) =>
      isInScreenshotMode
        ? css`
            display: flex;
            order: 1;
            width: 100vw;
          `
        : ''}
  }

  @media ${DEVICE.MOBILE_PORTRAIT} {
    position: absolute;
    height: ${({ isSidebarOpen }) => (isSidebarOpen ? '51.5%' : '100%')};
    width: 100%;
    top: 0;
  }

  @media ${DEVICE.MOBILE_LANDSCAPE} {
    position: absolute;
    height: 100%;
    width: ${({ isSidebarOpen }) =>
      isSidebarOpen
        ? css`calc(100% - (${SIDEBAR_WIDTH}px) - env(safe-area-inset-left))`
        : '100%'};
    right: 0;
  }
`;
